<section class="ts1-form-section">
	<div class="ts1-form-section__header">Assessment Configuration</div>

	@if (maneuvers.length > 0) {
		<app-ts1-overall-ob-count-summary
			[maneuvers]="maneuvers"
			[formTypeCode]="formTypeCode"
		></app-ts1-overall-ob-count-summary>
	}

	<div class="ts1-assessment-config flex min-h-[400px]">
		@if (maneuvers.length === 0) {
			<div class="ts1-assessment-empty flex min-h-[400px] flex-1">
				@if (!readOnly) {
					<div class="ts1-assessment-empty-sidebar">
						<button type="button" class="ts1-add-maneuver-btn" (click)="onAddManeuverClick()">
							<span class="plus-icon">+</span>
							<span>Add Maneuver</span>
						</button>
					</div>
				}

				<div class="ts1-assessment-panel flex-1">
					<app-ts1-assessment-ob-table
						[previewMode]="true"
						[formTypeCode]="formTypeCode"
						[maneuverAction]="maneuverAction"
					></app-ts1-assessment-ob-table>
				</div>
			</div>
		} @else {
			<app-ts1-maneuver-sidebar
				[maneuvers]="maneuvers"
				[activeIndex]="activeIndex"
				[readOnly]="readOnly"
				(activeIndexChange)="activeIndex = $event"
				(removeManeuver)="onRemove($event)"
				(addManeuver)="onAddManeuverClick()"
			></app-ts1-maneuver-sidebar>

			<div class="ts1-assessment-panel flex-1">
				@if (maneuvers.at(activeIndex)) {
					<app-ts1-assessment-ob-table
						[maneuverForm]="$any(maneuvers.at(activeIndex))"
						[maneuverAction]="maneuverAction"
						[readOnly]="readOnly"
					></app-ts1-assessment-ob-table>
				}
			</div>
		}
	</div>
</section>
